import React, { createContext, useContext, useState } from 'react';

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [loadingStepper, setLoadingStepper] = useState(false);

  const showLoader = () => setLoading(true);
  const hideLoader = () => setLoading(false);
  const showStepperLoader = () => setLoadingStepper(true);
  const hideStepperLoader = () => setLoadingStepper(false);

  return (
    <LoaderContext.Provider value={{ loading, showLoader, hideLoader,loadingStepper,showStepperLoader ,hideStepperLoader}}>
      {children}

    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);
